import React from 'react';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
import { useForm } from '../../../../contexts/form-context';
import { useSubmitButton } from '../../../../fields/submit-button/submit-button/use-submit-button';
import { useFieldActions } from '../../../../contexts/field-actions-context';
import { FieldPropsContext } from '../../../../contexts/field-props-context';
import { FIELD_PROPS_MAPPERS } from '../../../../mappers/public-props-map';
export const SubmitButtonField = _ref => {
  let {
    field,
    FieldLayout
  } = _ref;
  const {
    submitText,
    nextText,
    previousText,
    text
  } = field.properties;
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();
  const {
    actions
  } = useFieldActions();
  const {
    handleSubmitClick,
    isDisabled,
    isInProgress,
    showPreviousButton,
    showNextButton,
    showSubmitButton,
    hasSteps
  } = useSubmitButton({
    form,
    id: field.id
  });
  const submitButtonText = submitText || text || '';
  const previousButtonText = previousText || '';
  const nextButtonText = nextText || '';
  const propsMapper = FIELD_PROPS_MAPPERS[field.fieldType];
  const FieldComponent = componentsById[field.fieldType];
  if (!FieldComponent) {
    return null;
  }
  const fieldProps = {
    ...field.properties,
    id: field.id,
    externalData,
    fieldType: field.fieldType,
    FieldLayout,
    hasSteps,
    isDisabled,
    isInProgress,
    showPreviousButton,
    showNextButton,
    showSubmitButton,
    submitText: submitButtonText,
    previousText: previousButtonText,
    nextText: nextButtonText,
    onSubmitClick: handleSubmitClick,
    onPreviousClick: () => actions == null ? void 0 : actions.setPreviousStep(),
    onNextClick: () => actions == null ? void 0 : actions.setNextStep()
  };
  return /*#__PURE__*/React.createElement(FieldPropsContext.Provider, {
    value: {
      ...propsMapper({
        ...field.properties,
        id: field.id,
        externalData,
        fieldType: field.fieldType,
        hasSteps,
        isDisabled,
        isInProgress,
        showPreviousButton,
        showNextButton,
        showSubmitButton,
        submitText: submitButtonText,
        previousText: previousButtonText,
        nextText: nextButtonText,
        onSubmitClick: handleSubmitClick,
        onPreviousClick: () => actions == null ? void 0 : actions.setPreviousStep(),
        onNextClick: () => actions == null ? void 0 : actions.setNextStep()
      }),
      v2: fieldProps
    }
  }, /*#__PURE__*/React.createElement(FieldComponent, fieldProps));
};
//# sourceMappingURL=submit-button-field.js.map